module.exports = __webpack_public_path__ + "img/robot.6028f8.svg";